require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ./~/angular-cookies/index.js
// module id = 15
// module chunks = 2